import React, { FC } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';

type TFooterProps = {
  onClose: () => void;
  onLogout: () => void;
};

export const Footer: FC<TFooterProps> = ({ onClose, onLogout }) => {
  const { pathname } = useLocation();
  const history = useHistory();

  const menues: { label: string; isActive?: boolean; clickHandler: () => void }[] = [
    {
      label: 'Profile settings',
      isActive: pathname === '/profile',
      clickHandler: () => history.push('/profile'),
    },
    {
      label: 'Logout',
      clickHandler: onLogout,
    },
  ];

  return (
    <SBottomSection>
      {menues.map(({ label, clickHandler, isActive }) => (
        <SItem
          key={label}
          $active={!!isActive}
          onClick={() => {
            clickHandler();
            onClose();
          }}
        >
          {label}
        </SItem>
      ))}
    </SBottomSection>
  );
};

const SBottomSection = styled.div`
  font-size: 16px;
  font-weight: 500;
  font-family: 'aesthet-nova';
  border-top: 1px solid #fcc425;
  margin-top: 16px;
  padding-top: 16px;
`;

const SItem = styled.div<{ $active: boolean }>`
  cursor: pointer;
  margin: 16px 63px;
  padding: 14px 24px;
  border-radius: 8px;
  background-color: ${({ $active }) => ($active ? 'black' : 'transparent')};
  color: ${({ $active }) => ($active ? 'white' : '#0d0d0d')};
  font-size: 16px;

  &:hover {
    background-color: ${({ $active }) => ($active ? 'black' : 'rgba(0, 0, 0, 0.04)')};
  }
`;
